export class User {
  constructor({
    user_id,
    company_code,
    company_id,
    displayName,
    email,
    first,
    id,
    last,
    memberSince,
    phone,
    phoneNumber,
    photoURL,
    updated_at,
  }){
    this.user_id = user_id
    this.company_code = company_code
    this.company_id = company_id
    this.displayName = displayName
    this.email = email
    this.first = first
    this.id = id
    this.last = last
    this.memberSince = memberSince
    this.phone = phone
    this.phoneNumber = phoneNumber
    this.photoURL = photoURL
    this.updated_at = updated_at
  }
}

export const UserConverter = {
  toFirestore: function(user) {
    return {
      user_id: user.user_id,
      company_code: user.company_code,
      company_id: user.company_id,
      displayName: user.displayName,
      email: user.email,
      first: user.first,
      last: user.last,
      id: user.id,
      memberSince: user.memberSince,
      phone: user.phone,
      phoneNumber: user.phoneNumber,
      photoURL: user.photoURL,
      updated_at: Timestamp.now(),
    };
  },
  fromFirestore: function(snapshot, options){
    const data = snapshot.data(options);
    return new User({
      user_id: data.user_id ||  snapshot.id,
      company_code: data.company_code,
      company_id: data.company_id,
      displayName: data.displayName,
      email: data.email,
      first: data.first,
      id: snapshot.id,
      last: data.last,
      memberSince: data.memberSince,
      phone: data.phone,
      phoneNumber: data.phoneNumber,
      photoURL: data.photoURL,
      updated_at: data.updated_at?.toDate(),
    });
  }
}